import { render } from "./FedexSchedulesDetailsPage.vue?vue&type=template&id=54f42812&scoped=true"
import script from "./FedexSchedulesDetailsPage.vue?vue&type=script&lang=js"
export * from "./FedexSchedulesDetailsPage.vue?vue&type=script&lang=js"

import "./FedexSchedulesDetailsPage.vue?vue&type=style&index=0&id=54f42812&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f42812"]])

export default __exports__